import { warnOnce } from '@mui/x-internals/warning';
import { processDate } from "../process-date/index.mjs";
import { resolveEventDate } from "./resolveEventDate.mjs";
export function processEvent(model, displayTimezone, adapter, recurringEventsPlugin = null) {
  const dataTimezone = model.timezone ?? 'default';
  const startInstant = resolveEventDate(model.start, dataTimezone, adapter);
  const endInstant = resolveEventDate(model.end, dataTimezone, adapter);
  const resolvedExDates = model.exDates ? model.exDates.map(exDate => resolveEventDate(exDate, dataTimezone, adapter)) : undefined;
  const startInDisplayTz = adapter.setTimezone(startInstant, displayTimezone);
  const endInDisplayTz = adapter.setTimezone(endInstant, displayTimezone);
  const exDatesInDisplayTz = resolvedExDates ? resolvedExDates.map(exDate => adapter.setTimezone(exDate, displayTimezone)) : undefined;
  if (recurringEventsPlugin == null && model.rrule != null) {
    if (process.env.NODE_ENV !== 'production') {
      warnOnce(['MUI X Scheduler: Recurring events are a premium feature. The `rrule` property will be ignored.', 'Use <EventCalendarPremium /> or <EventTimelinePremium /> to enable recurring events.']);
    }
  }
  const parsedDataRRule = recurringEventsPlugin && model.rrule ? recurringEventsPlugin.parseRRule(adapter, model.rrule, dataTimezone) : undefined;
  const displayTimezoneRRule = recurringEventsPlugin && parsedDataRRule ? recurringEventsPlugin.projectRRuleToTimezone(adapter, parsedDataRRule, displayTimezone, startInstant) : undefined;
  return {
    id: model.id,
    title: model.title,
    description: model.description,
    dataTimezone: {
      start: processDate(startInstant, adapter),
      end: processDate(endInstant, adapter),
      timezone: dataTimezone,
      rrule: parsedDataRRule,
      exDates: resolvedExDates
    },
    displayTimezone: {
      start: model.allDay ? processDate(adapter.startOfDay(startInDisplayTz), adapter) : processDate(startInDisplayTz, adapter),
      end: model.allDay ? processDate(adapter.endOfDay(endInDisplayTz), adapter) : processDate(endInDisplayTz, adapter),
      timezone: displayTimezone,
      rrule: displayTimezoneRRule,
      exDates: exDatesInDisplayTz
    },
    resource: model.resource,
    allDay: model.allDay ?? false,
    readOnly: model.readOnly ?? false,
    extractedFromId: model.extractedFromId,
    modelInBuiltInFormat: model,
    color: model.color,
    draggable: model.draggable,
    resizable: model.resizable,
    className: model.className
  };
}